import store from "@/store";

export default [
  {
    name: "New/Ticket",
    path: "/new/ticket"
  },
  {
    name: "New/Equipment",
    path: "/new/equipment",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/adminAndUp"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  },
  {
    name: "New/RecurringTask",
    path: "/new/recurring-task/:equipId",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/userWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  },
  {
    name: "New/SparePart",
    path: "/new/consumable/:equipId",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/userWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  },
  {
    name: "New/Inspection",
    path: "/new/inspection/:equipId"
  },
  {
    name: "New/Reliability",
    path: "/new/reliability/:equipId",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/reliabilityWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  },
  {
    name: "New/RepairLog",
    path: "/new/repairlog/:equipId",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/reliabilityWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  },
  {
    name: "New/Stocks",
    path: "/new/stocks/",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/equipmentWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  }
];
